
import { isFunction, isPlainObject } from "@/utils/utils"
import { toRoute } from "@/plugins/navigation"

export default {
  name: "ALink",
  inheritAttrs: false,
  props: {
    to: {
      type: [String, Object, Function],
      default: ""
    }
  },
  // TODO 不知道为何a-link组件缓存会引发TopContent组件重复渲染
  // serverCacheKey: props => props.to,
  computed: {
    isFunction() {
      return isFunction(this.to)
    },
    redirectTo() {
      return this.isFunction ? null : toRoute(this.to)
    },
    isRoute() {
      return !this.isFunction && (this.redirectTo === "/" || isPlainObject(this.redirectTo))
    }
  },
  methods: {
    handleClick(...args) {
      if (isFunction(this.to)) {
        this.to(...args)
      }
    }
  }
}
